import { render, staticRenderFns } from "./Accessorials.vue?vue&type=template&id=d70ec6e4&scoped=true&"
import script from "./Accessorials.vue?vue&type=script&lang=js&"
export * from "./Accessorials.vue?vue&type=script&lang=js&"
import style0 from "./Accessorials.vue?vue&type=style&index=0&id=d70ec6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70ec6e4",
  null
  
)

export default component.exports